import React, { useState } from "react";
import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";
import TimeField from "../../components/TimeField";

function TimeFieldStoryComponent() {
    const [time, setTime] = useState(100);

    return (
        <VStack gap={0.5} style={{ padding: 10, alignSelf: "stretch" }}>
            <TimeField value={time} onChange={setTime} />
        </VStack>
    );
}

const meta = {
    title: "Fields/Time",
    component: TimeFieldStoryComponent,
    argTypes: {},
} satisfies Meta<typeof TimeFieldStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
